export class SignalData {
    SignalLevel: number;
    Operator: string;
}
